import React from "react";
import HeroSection from "./HeroSection";
import RewardsSection from "./RewardsSection";
import EventInfoSection from "./EventInfoSection";
import CategoriesSection from "./CategoriesSection";
import RegistrationSection from "./RegistrationSection";
import ContactSection from "./ContactSection";

const MainPage = () => {
  return (
    <>
      <HeroSection />
      <RewardsSection />
      <section id="venue">
        <EventInfoSection />
      </section>
      <section id="category">
        <CategoriesSection />
      </section>
      <section id="register">
        <RegistrationSection />
      </section>
      <ContactSection />
    </>
  );
};

export default MainPage;
